import React from 'react';
import PropTypes from 'prop-types';

import Locale from '../../Translate/Locale';
import Text from '../../common/Text';
import StatusBadge from '../../common/StatusBadge';
import PlainButton from '../../common/PlainButton';
import EventStatusBadge from '../EventStatusBadge';
import ClaimStatusBadge from '../ClaimStatusBadge/ClaimStatusBadge';
import ClaimTypeBadge from '../../claims-center/ClaimsTable/ClaimsTypeBadge';

import ViewIcon from '../../../icons/view.svg';

import './ResultHeader.scss';
import { generateNameFromText } from '../../../slug';
import ClaimsTableSubmissionDate from '../../claims-center/ClaimsTable/ClaimsTableSubmissionDate';
import DorStatusBadge from '../../claims-center/ClaimsTable/DorStatusBadge';

function ResultHeader(props) {
  const {
    name,
    labelForId,
    id,
    lastEvent,
    link,
    children,
    showDetailsButton,
    claimStatus,
    showClaimedTag,
    showDeadline,
    lastSubmissionDate,
    claimSubmittedAt,
    claimType,
    dorStatus,
  } = props;
  const buttonName = generateNameFromText(`${name} view details`);

  return (
    <div styleName="header">
      <div styleName="header-row">
        <StatusBadge neutral>{name}</StatusBadge>
        {id && (
          <React.Fragment>
            <Text styleName="label">
              <Locale>{labelForId}</Locale>:
            </Text>
            <Text styleName="id" ink>
              {id}
            </Text>
          </React.Fragment>
        )}
        <div styleName="details">
          {children && <div styleName="children">{children}</div>}
          {showDetailsButton && (
            <a styleName="link" href={link} target="_blank">
              <PlainButton icon={ViewIcon} name={buttonName}>
                View details
              </PlainButton>
            </a>
          )}
        </div>
      </div>
      <div styleName="status-row">
        {lastEvent && (
          <div styleName="status-container">
            <Text>
              <Locale>{name} status</Locale>
            </Text>
            <div styleName="labeled-badge">
              <EventStatusBadge meaning={lastEvent.meaning} type={lastEvent.type} />
            </div>
          </div>
        )}
        {showClaimedTag && (
          <div styleName="status-container">
            <Text>
              <Locale>Claim status</Locale>
            </Text>
            <div styleName="labeled-badge">
              <ClaimStatusBadge status={claimStatus} />
            </div>
            <Text>
              <Locale>Claim type</Locale>
            </Text>
            <div styleName="labeled-badge">
              <ClaimTypeBadge claimType={claimType} />
            </div>

            {showDeadline && (
              <>
                <Text>
                  <Locale>Deadline:</Locale>
                </Text>
                <div styleName="labeled-badge">
                  <ClaimsTableSubmissionDate
                    claim={{
                      deadlineLastSubmissionDate: lastSubmissionDate || null,
                      submittedAt: claimSubmittedAt || null,
                      status: claimStatus,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        )}
        {!!dorStatus && (
          <div styleName="status-container">
            <Text>
              <Locale>DOR</Locale>
            </Text>
            <div styleName="labeled-badge">
              <DorStatusBadge dorStatus={dorStatus} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

ResultHeader.propTypes = {
  name: PropTypes.string,
  labelForId: PropTypes.string,
  id: PropTypes.string, // tracking code or shop order id
  lastEvent: PropTypes.object,
  link: PropTypes.string,
  showClaimedTag: PropTypes.bool,
  claimStatus: PropTypes.string,
  claimType: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(ResultHeader);
